import React, { useState, useEffect, useCallback } from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Grid,
  Box,
  FormGroup,
  Divider,
  Chip,
  Autocomplete,
  CircularProgress,
  Slide,
  Tooltip,
  Popover,
  Modal,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Paper,
  Popper,
  Fade,
  Badge,
} from "@mui/material";
import {
  Folder,
  InsertDriveFile,
  ConfirmationNumber,
  Event,
  ArrowBack,
  ArrowForward,
  Delete,
  Add,
  Person,
  CheckCircle,
  Cancel,
  Schedule,
  Label,
  Assignment,
  Create,
  Update,
  Done,
  CloudUpload,
} from "@mui/icons-material";
import Link from '@mui/material/Link';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import "./Crm.css";
import { ListItemService } from "../../../service/manage/crm/crm_list_item.service";
import DropdownCust from "./Components/DropdownCust";
import TextFieldCust from "./Components/TextfieldCust";
import { FieldListService } from "../../../service/manage/crm/crm_field_list.service";
import { debounce } from "lodash";
import { CrmMainService } from "../../../service/manage/crm/crm_main.service";
import sweetAlert,{ sweetAlertTryagain, sweetBlockSaveAlert, sweetConfirmAlert, sweetStatusAlert } from "../../../components/common/SweetAlert";
import SimpleReactValidator from "simple-react-validator";
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import AddLinkIcon from '@mui/icons-material/AddLink';
import BookmarkButton from "./Components/BookmarkButton";
import BlockLinkModal from "./Components/BlockLinkModal";
import Checkbox from '@mui/material/Checkbox';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import CancelIcon from '@mui/icons-material/Cancel';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import DriveFolderUploadRoundedIcon from '@mui/icons-material/DriveFolderUploadRounded';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export default function AnchorTemporaryDrawer({
  open,
  onClose,
  selectedSearchFilter,
  state,
  handleSearchFilter,
  prevTicket,
  nextTicket,
  onNavigate,
  handleFilterForLinkedBlocks,
  fetchAllReminders
}) {


  const [trialTitle, setTrialTitle] = useState("");
  const [blockGroupName, setBlockGroupName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [shortText, setShortText] = useState("");
  const [longText, setLongText] = useState("");
  const [reminders, setReminders] = useState([]);
  const [eta, setEta] = useState(null);
  const [searchTags, setSearchTags] = useState("");
  const [blockOwners, setBlockOwners] = useState([]);
  const [blockCreator, setBlockCreator] = useState("");
  const [mappingLinks, setMappingLinks] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedOption, setSelectedOption] = useState(17);
  const [taskStatusArr, setTaskStatusArr] = useState([]);
  const [blockStatusArr, setBlockStatusArr] = useState([]);
  const [selectedTaskStatus, setSelectedTaskStatus] = useState("");
  const [selectedBlockStatus, setSelectedBlockStatus] = useState("");
  const [statusesLoading, setStatusesLoading] = useState(false);
  const [isUserLoading, setisUserLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [sortColumn, setSortColumn] = useState("user_code");
  const [sortDirection, setSortDirection] = useState("desc");
  const [selectedBlockCreator, setSelectedBlockCreator] = useState(null);
  const [nextBlockTitle, setNextBlockTitle] = useState("");
  const [parentBlockTitle, setParentBlockTitle] = useState("");
  const [dateTimeCreated, setDateTimeCreated] = useState("");
  const [dateTimeDone, setDateTimeDone] = useState("");
  const [dateTimeLastUpdate, setDateTimeLastUpdate] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);

  const [slideDirection, setSlideDirection] = useState("left");
  const [isSliding, setIsSliding] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [openSlide, setOpenSlide] = useState(true);
  const [, forceUpdate] = useState({});

  const [modalOpen, setModalOpen] = useState(false);
  const [linkedBlocks, setLinkedBlocks] = useState([]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const [linkedBlocksForSearch, setLinkedBlocksForSearch] = useState([])
  const [isChanged, setIsChanged] = useState({
    bookmark:false,
    textfields:false,
  })
  const [linkedAnchorEl, setLinkedAnchorEl] = React.useState(null);
  const [openLinked, setOpenLinked] = React.useState(false);

  const handleIsChange = (key, value) => {    
    setIsChanged((prevState) => ({
        ...prevState,
        [key]: value,
    }));
};


  const [validator] = useState(() => {
    const validator = new SimpleReactValidator({
      className: "text-danger",
    });
    return validator;
  });

  const resetState = () => {
    setTrialTitle("");
    setBlockGroupName("");
    setBlockName("");
    setShortText("");
    setLongText("");
    setReminders([]);
    setEta(null);
    setSearchTags("");
    setBlockOwners([]);
    setBlockCreator("");
    setMappingLinks("");
    setAttachments([]);
    setSelectedOption("blockGroupName");
    setTaskStatusArr([]);
    setBlockStatusArr([]);
    setSelectedTaskStatus("");
    setSelectedBlockStatus("");
    setStatusesLoading(false);
    setisUserLoading(false);
    setUsers([]);
    setUserSearchTerm("");
    setSortColumn("user_code");
    setSortDirection("desc");
    setSelectedBlockCreator(null);
    setDateTimeCreated("");
    setDateTimeDone("");
    setDateTimeLastUpdate("");
  };

  useEffect(() => {
    if (!open) {
      resetState();
      setLinkedBlocksForSearch([])
      validator.hideMessages();
      forceUpdate({});
    }
  }, [open]);

  useEffect(() => {
    if (open || isNavigating) {
      resetState();
      setLinkedBlocksForSearch([])
      fetchAllUsers();
      fetchDropdownOptions();

      if (selectedSearchFilter) {
        setTrialTitle(selectedSearchFilter.f12 || "");
        setBlockGroupName(selectedSearchFilter.f17 || "");
        setBlockName(selectedSearchFilter.f18 || "");
        setShortText(selectedSearchFilter.f19 || "");
        setLongText(selectedSearchFilter.f20 || "");
        //setting the ETA
        if (selectedSearchFilter.f22) {
          const parsedDate = new Date(selectedSearchFilter.f22);
          if (!isNaN(parsedDate)) {
            setEta(parsedDate);
          }
        } else {
          setEta(null);
        }
        setSearchTags(selectedSearchFilter.f23 || "");
        setSelectedTaskStatus(selectedSearchFilter.f25 || "");
        setSelectedBlockStatus(selectedSearchFilter.f29 || "");
        setSelectedOption(selectedSearchFilter?.f15);
        //setting block owners
        if (selectedSearchFilter.f24) {
          const transformedBlockOwners = selectedSearchFilter.f24
            .map((owner) => {
              const [displayOrder, userId, userTableId] = owner
                .slice(1, -1)
                .split(",");
              return userId && userTableId ? `${userId}|${userTableId}` : null;
            })
            .filter(Boolean);

          setBlockOwners(
            transformedBlockOwners.length ? transformedBlockOwners : []
          );
        }

        //setting the reminders
        if (selectedSearchFilter?.f21) {
          const transformedReminders = selectedSearchFilter.f21
            .map((reminder) => {
              // Check if the reminder string is invalid (e.g., "(,,)")
              if (reminder === "(,,)") {
                console.warn("Invalid reminder format:", reminder);
                return null;
              }
        
              // Remove parentheses and split the components
              const parts = reminder.slice(1, -1).split(",");
              const displayOrder = parts[0];
              const dateString = parts[1];
              const type = parts[2]?.replace(/"/g, "").trim() || "";
        
              // Parse the date string (format: YYYYMMDDHHMI)
              let date = null;
              if (dateString && dateString.length >= 12) {
                const year = parseInt(dateString.substring(0, 4), 10);
                const month = parseInt(dateString.substring(4, 6), 10) - 1; // Months are 0-indexed
                const day = parseInt(dateString.substring(6, 8), 10);
                const hours = parseInt(dateString.substring(8, 10), 10);
                const minutes = parseInt(dateString.substring(10, 12), 10);
        
                date = new Date(year, month, day, hours, minutes);
                
                if (isNaN(date.getTime())) {
                  console.warn("Invalid reminder date:", dateString);
                  return null;
                }
              }
        
              return {
                date,
                displayOrder: parseInt(displayOrder, 10),
                type,
              };
            })
            .filter(Boolean);
        
          setReminders(transformedReminders);
        }

        //setting dateTimeCreated, dateTimeDone, and dateTimeLastUpdate
        const formatDate = (dateString) => {
          if (!dateString) return "";

          const date = new Date(dateString);
          if (isNaN(date.getTime())) return "";

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours() % 12 || 12).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const ampm = date.getHours() >= 12 ? "PM" : "AM";

          return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
        };

        if (selectedSearchFilter.f26) {
          setDateTimeCreated(formatDate(selectedSearchFilter.f26));
        }
        if (selectedSearchFilter.f27) {
          setDateTimeDone(formatDate(selectedSearchFilter.f27));
        }
        if (selectedSearchFilter.f28) {
          setDateTimeLastUpdate(formatDate(selectedSearchFilter.f28));
        }
        if (selectedSearchFilter?.f31) {
          const transformedBlockLinks = selectedSearchFilter.f31
            .map((block) => {
              // Check if the reminder string is invalid (e.g., "(,,)")
              if (block === "(,,)") {
                console.warn("Invalid reminder format:", block);
                return null;
              }

              const [block_id, displayOrder, comment] = block
                .slice(1, -1)
                .split(",");

              return {
                block_id: parseInt(block_id),
                displayOrder: parseInt(displayOrder),
                comment
              };
            })
            .filter(Boolean);

          setLinkedBlocks(transformedBlockLinks);
        }
      }
    }
  }, [open, selectedSearchFilter]);

  const findAndSetBlockCreator = (users, f30) => {
    if (!f30) {
      setBlockCreator("");
      return;
    }

    try {
      const f30String = f30.replace(/["{}]/g, "");

      const [userId, userTableId] = f30String.slice(1, -1).split(",");
      const userIdNumber = parseInt(userId, 10);
      const userTableIdNumber = parseInt(userTableId, 10);

      const matchedUser = users.find(
        (user) =>
          user.user_id === userIdNumber &&
          user.user_table_id === userTableIdNumber
      );

      if (matchedUser) {
        setBlockCreator(matchedUser.data_concat);
      } else {
        setBlockCreator("");
      }
    } catch (error) {
      console.error("Error parsing f30:", error);
      setBlockCreator("");
    }
  };

  useEffect(() => {
    if (prevTicket) {
      setParentBlockTitle(prevTicket.f16);
    } else {
      setParentBlockTitle("");
    }
    if (nextTicket) {
      setNextBlockTitle(nextTicket.f16);
    } else {
      setNextBlockTitle("");
    }
  }, [prevTicket, nextTicket]);

  const formatRemindersForSubmission = (reminders) => {
    return reminders.map((reminder) => {
      if (!reminder.date) {
        return `|${reminder.displayOrder}|${reminder.type}`;
      }
      
      const date = new Date(reminder.date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
  
      const formattedDate = `${year}${month}${day}${hours}${minutes}`;
      return `${formattedDate}|${reminder.displayOrder}|${reminder.type}`;
    });
  };

  const formatDateToYYYYMMDDHHmm = (date) => {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}${hours}${minutes}`;
  };

  const fetchDropdownOptions = async () => {
    try {
      setStatusesLoading(true);

      const [taskStatusResponse, blockStatusResponse] = await Promise.all([
        ListItemService.getListItemById(25),
        ListItemService.getListItemById(29),
      ]);

      setTaskStatusArr(taskStatusResponse.data);
      setBlockStatusArr(blockStatusResponse.data);

      setStatusesLoading(false);
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
      setStatusesLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    setisUserLoading(true);

    try {
      const response = await FieldListService.getAllCrmUsers(
        state?.mid,
        state?.form_list_id,
        state?.lg_user_id,
        state?.lg_user_table_id,
        5000,
        0,
        sortColumn,
        sortDirection,
        userSearchTerm
      );
      setUsers(response?.data?.users || []);

      if (selectedSearchFilter.f30) {
        findAndSetBlockCreator(response?.data?.users, selectedSearchFilter.f30);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setisUserLoading(false);
    }
  };

  const handleUserSelect = (event, selectedOption) => {
    setSelectedBlockCreator(selectedOption);

    if (selectedOption) {
      setBlockCreator(
        `${selectedOption.user_id}|${selectedOption.user_table_id}`
      );
    } else {
      setBlockCreator("");
    }
  };

  const handleUserSearch = (inputValue) => {
    setUserSearchTerm(inputValue);
  };

  const handleBlockOwnersSelect = (event, selectedOptions) => {
    const selectedUsers = selectedOptions.map(
      (option) => `${option.user_id}|${option.user_table_id}`
    );
    setBlockOwners(selectedUsers);
  };

  const handleTaskStatusChange = (event) => {
    setSelectedTaskStatus(event.target.value);
  };

  const handleBlockStatusChange = (event) => {
    setSelectedBlockStatus(event.target.value);
    validator.showMessageFor("selectedBlockStatus");
  };

  const addReminder = () => {
    if (reminders.length === 0 || reminders[reminders.length - 1] !== null) {
      setReminders([
        ...reminders,
        { date: null, displayOrder: reminders.length + 1, type: "" },
      ]);
    }
  };

  const handleReminderChange = (date, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].date = date;
    setReminders(updatedReminders);
  };

  const handleTypeChange = (event, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].type = event.target.value;
    setReminders(updatedReminders);
  };

  const removeReminder = (index) => {
    const updatedReminders = reminders.filter((_, i) => i !== index);
    setReminders(updatedReminders);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(Number(event.target.value));
  };

  const getTitle = () => {
    switch (selectedOption) {
      case 17:
        return blockGroupName;
      case 18:
        return blockName;
      case 19:
        return shortText;
      default:
        return "";
    }
  };

  const handleSave = async () => {
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }
    try {
      setSaveLoading(true);

      const formattedReminders = formatRemindersForSubmission(reminders);
      const formattedEta = formatDateToYYYYMMDDHHmm(eta);

      const fomattedBlockLinks = formatBlockLinkForSubmission(linkedBlocks)


      const payload = {
        node_id: state?.mid,
        user_id: state?.lg_user_id,
        user_table_id: state?.lg_user_table_id,
        create_user_id: state?.lg_user_id,
        create_user_table_id: state?.lg_user_table_id,
        trail_id: selectedSearchFilter?.f11,
        trail_title: trialTitle,
        display_order: selectedSearchFilter?.f13,
        block_id: selectedSearchFilter?.f14,
        block_title_id: selectedOption,
        block_title: selectedSearchFilter?.f16,
        block_group_name: blockGroupName,
        block_name: blockName,
        short_text: shortText,
        long_text: longText,
        reminders: formattedReminders,
        eta: formattedEta,
        search_tags: searchTags,
        block_owners: blockOwners,
        task_status: parseInt(selectedTaskStatus),
        block_status: parseInt(selectedBlockStatus),
        parent_block_id: selectedSearchFilter?.f33,
        next_block_id: selectedSearchFilter?.f35,
        mappings: fomattedBlockLinks,
      };

      const response = await CrmMainService.crm_update_block(payload);

      if (response.success) {
        setSaveLoading(false);
        sweetStatusAlert("Success!", response.message.success, "success");

        handleCloseModal();

        await fetchAllReminders();
        await handleSearchFilter();     
      } else {
        setSaveLoading(false);
        sweetStatusAlert("Failed!", response.message, "error");
      }
    } catch (error) {
      setSaveLoading(false);
      sweetStatusAlert("Failed!", "Failed to update Block", "error");
    }
  };

  const handleCloseModal = () => {
    validator.hideMessages();
    forceUpdate({});
    setIsChanged({bookmark:false, textfields:false})
    onClose();
  };

  const handlePrev = () => {
    if (prevTicket && !isSliding) {
      setIsSliding(true);
      setOpenSlide(false);
      setSlideDirection("right");
      setIsNavigating(true);
      setTimeout(() => {
        onNavigate(prevTicket);
        setIsSliding(false);
        setIsNavigating(false);
        setOpenSlide(true);
      }, 300);
    }
  };

  const handleNext = () => {
    if (nextTicket && !isSliding) {
      setIsSliding(true);
      setOpenSlide(false);
      setSlideDirection("left");
      setIsNavigating(true);
      setTimeout(() => {
        onNavigate(nextTicket);
        setIsSliding(false);
        setIsNavigating(false);
        setOpenSlide(true);
      }, 300);
    }
  };

  const formatBlockLinkForSubmission = (linkedBlocks) => {
    return linkedBlocks.map((block, index) => {
      return `${block.block_id}|${block.displayOrder}|${block.comment}`;
    });
  };

  const handleAddLink = (comment, targetBlock) => {

    setLinkedBlocks((prevLinkedBlocks) => {
      const maxDisplayOrder = prevLinkedBlocks.reduce(
        (max, linkedBlock) => Math.max(max, linkedBlock.displayOrder),
        0
      );
      return [
        ...prevLinkedBlocks,
        {
          block_id: targetBlock.f14,
          displayOrder: maxDisplayOrder + 1,
          comment: comment,
        },
      ];
    });
    handleIsChange("bookmark", true);
  };

  const handleRemoveLink = (block) => {
    setLinkedBlocks((prevLinkedBlocks) => {
      const updatedLinkedBlocks = prevLinkedBlocks
        .filter((linkedBlock) => linkedBlock.block_id !== block.block_id)
        .map((linkedBlock, index) => ({
          ...linkedBlock,
          displayOrder: index + 1,
        }));
      return updatedLinkedBlocks;
    });
    handleIsChange("bookmark", true);
  };

  const handleSelectLinkBlockForSearch = async(event,block)=>{

    setLinkedBlocksForSearch(prev => {
      if (event.target.checked) {
        return [...prev, block]; 
      } else {
        return prev.filter(b => b.block_id !== block.block_id);
      }
    });
    
  }

  const handleFilterForLinkedBlocksSearch = async(linkedBlocksForSearch)=>{

    if(isChanged.bookmark){


      sweetBlockSaveAlert("You have unsaved changes","Save before closing",'warning')
      .then(async(res)=>{
        
        if(res){
          setOpenLinked(false)
          await handleSave();
          handleIsChange("bookmark",false)
          handleFilterForLinkedBlocks(linkedBlocksForSearch)
        }
        else{
          setOpenLinked(false)
          handleIsChange("bookmark",false)
          handleFilterForLinkedBlocks(linkedBlocksForSearch)
        }
        
      })

    }
    else{
      setOpenLinked(false)
      handleFilterForLinkedBlocks(linkedBlocksForSearch)
    }
    
  }

  const handleOpenLinkedTickets = async(event)=>{

    setLinkedAnchorEl(event.currentTarget);
    setOpenLinked(true);
  }

  const handleCloseDrawer = ()=>{

    if(isChanged && isChanged.bookmark){
      sweetAlert("Warning", "You've unsaved linked blocks, Save before closing","info")
        .then((res)=>{
          if(res === false){
            handleSave()
          }
          else{
            setIsChanged({bookmark:false, textfields:false})
            onClose()
          }
        })
    }
    else{
      setIsChanged({bookmark:false, textfields:false})
      onClose()
    }
  }

  useEffect(() => {
    setOpenLinked(false)
    setIsChanged({bookmark:false, textfields:false})
  }, [])

  const handleCloseLinkedModal = () => setOpenLinked(false);
  



  const list = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Slide
        direction={slideDirection}
        in={openSlide}
        mountOnEnter
        unmountOnExit
      >
        <Card
          style={{
            width: "600px",
            borderRadius: "10px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          <CardContent>
          <div className="d-flex align-items-center justify-content-between">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography
                variant="h6"
                style={{
                  fontWeight: "bold", color: "#172B4D",
                  borderRadius: '4px', padding: '4px',
                }}
              >
                {getTitle() || "N/A"}
              </Typography>
            </Box>            
            <BookmarkButton selectedSearchFilter={selectedSearchFilter} />
          </div>

            <Divider style={{ margin: "8px 0" }} />

            {/* Editable Fields */}
            <Grid container  sx={{ gap:'4px' }}>
              <Grid item xs={12}>
                <TextFieldCust
                  fullWidth
                  label="Trial Title"
                  value={trialTitle}
                  onChange={(e) => setTrialTitle(e.target.value)}
                  margin="normal"
                  variant="outlined"
                  error={validator.message(
                    "trialTitle",
                    trialTitle,
                    "required"
                  )}
                  helperText={validator.message(
                    "trialTitle",
                    trialTitle,
                    "required"
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <TextFieldCust
                  fullWidth
                  label="Block ID"
                  value={selectedSearchFilter?.f14}
                  margin="normal"
                  disabled
                  variant="outlined"
                />
              </Grid>
              {/* <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Block Title"
                  value={selectedSearchFilter?.f16}
                  margin="normal"
                  disabled
                  variant="outlined"
                />
              </Grid> */}
            </Grid>

            <FormControl component="fieldset" fullWidth>
              <FormGroup>
                <Box display="flex" alignItems="center" mb={1}>
                  <RadioGroup
                    value={selectedOption}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={17}
                      control={<Radio />}
                      label="Block Group Name"
                    />
                  </RadioGroup>
                  <TextFieldCust
                    fullWidth
                    value={blockGroupName}
                    onChange={(e) => setBlockGroupName(e.target.value)}
                    margin="normal"
                    label="Block Group Name"
                    variant="outlined"
                    error={validator.message(
                      "blockGroupName",
                      blockGroupName,
                      "required"
                    )}
                    helperText={validator.message(
                      "blockGroupName",
                      blockGroupName,
                      "required"
                    )}
                  />
                </Box>

                <Box display="flex" alignItems="center" mb={1}>
                  <RadioGroup
                    value={selectedOption}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={18}
                      control={<Radio />}
                      label="Block Name"
                    />
                  </RadioGroup>
                  <TextFieldCust
                    fullWidth
                    value={blockName}
                    onChange={(e) => setBlockName(e.target.value)}
                    margin="normal"
                    label="Block Name"
                    variant="outlined"
                    error={validator.message(
                      "blockName",
                      blockName,
                      "required"
                    )}
                    helperText={validator.message(
                      "blockName",
                      blockName,
                      "required"
                    )}
                  />
                </Box>

                <Box display="flex" alignItems="center" mb={1}>
                  <RadioGroup
                    value={selectedOption}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value={19}
                      control={<Radio />}
                      label="Short Text"
                    />
                  </RadioGroup>
                  <TextFieldCust
                    fullWidth
                    value={shortText}
                    onChange={(e) => setShortText(e.target.value)}
                    margin="normal"
                    label="Short Text"
                    variant="outlined"
                    error={validator.message(
                      "shortText",
                      shortText,
                      "required"
                    )}
                    helperText={validator.message(
                      "shortText",
                      shortText,
                      "required"
                    )}
                  />
                </Box>
              </FormGroup>
            </FormControl>

          <div style={{gap:'8px', display:'flex', flexDirection:'column'}}>
            <TextFieldCust
              fullWidth
              label="Long Text"
              value={longText}
              onChange={(e) => setLongText(e.target.value)}
              multiline
              rows={4}
            />

            {reminders.map((reminder, index) => (
              <Grid
                container
                key={index}
                spacing={2}
                alignItems="center"
                style={{
                  marginBottom: 10,
                  padding: 10,
                  borderRadius: 8,
                }}
              >              
                <Grid item xs={6}>
                  {/* <Box sx={{ mb:'4px' }}> */}
                  <DatePicker  
                    className="date-picker-custom"
                    selected={reminder.date}
                    onChange={(date) => handleReminderChange(date, index)}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                    calendarClassName="custom-calendar"
                    popperClassName="custom-popper"
                    placeholderText="Select date and time"
                    minDate={new Date()}
                    autoComplete="off"
                    onChangeRaw={(e) => e.preventDefault()}  // Prevents manual typing
                    onFocus={(e) => e.target.blur()}        // Prevents cursor appearance
                    popperPlacement="bottom-start"           // Controls calendar popup position
                  />
                  {/* </Box> */}
                </Grid>
                <Grid item xs={4}>
                  <TextFieldCust
                    value={reminder.type}
                    onChange={(event) => handleTypeChange(event, index)}
                    placeholder="Type your reminder here"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeReminder(index)}
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                  {index === reminders.length - 1 && reminder.date !== null && (
                    <IconButton
                      onClick={addReminder}
                      color="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      <Add />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </div>
            {reminders.length === 0 && (
              <Button
                onClick={addReminder}
                variant="outlined"
                startIcon={<Add />}
                style={{ marginTop: "10px" }}
              >
                Add Reminder
              </Button>
            )}

            <Box display="flex" alignItems="center" mt={1} mb={1}>
              <Schedule color="primary" /> &nbsp;
              <p className="DateNTime"> 
                Date & Time – ETA
              </p>
            </Box>
            <div style={{gap:'8px', display:'flex', flexDirection:'column'}}>
            <DatePicker
              className="date-picker-custom"
              selected={eta}
              onChange={(date) => setEta(date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              calendarClassName="custom-calendar"
              popperClassName="custom-popper"
              placeholderText="Select date and time"
              minDate={new Date()}
              autoComplete="off"
              margin="normal"
              onChangeRaw={(e) => e.preventDefault()}  // Prevents manual typing
              onFocus={(e) => e.target.blur()}        // Prevents cursor appearance
              popperPlacement="bottom-start"           // Controls calendar popup position
            />
            <p className="DateNTime">Search Tag(s)</p>
            <TextFieldCust
              fullWidth
              label="Search Tag(s)"
              value={searchTags}
              onChange={(e) => setSearchTags(e.target.value)}
              margin="normal"
              variant="outlined"
            />
          </div>
          <Box mt={2} mb={2}>
            <Typography variant="body2">
              <Person color="primary" style={{ marginRight: "10px" }} />
              Block Owner(s)
            </Typography>
            <Autocomplete
              multiple
              freeSolo
              options={users}
              getOptionLabel={(option) => option.data_concat}
              value={users.filter((user) =>
                blockOwners.includes(`${user.user_id}|${user.user_table_id}`)
              )}
              onChange={handleBlockOwnersSelect}
              onInputChange={(event, newInputValue) =>
                setUserSearchTerm(newInputValue)
              }
              loading={isUserLoading}
              renderInput={(params) => (
                <TextField {...params} placeholder="Select block owners..." />
              )}
            />
          </Box>

            <Box mt={1} mb={1}>
              <Typography variant="body2">
                <Assignment color="primary" style={{ marginRight: "10px" }} />
                Task Status
              </Typography>
              <DropdownCust
                value={selectedTaskStatus}
                onChange={handleTaskStatusChange}
                disabled={statusesLoading}
                placeholder="Select.."
              >
                {statusesLoading ? (
                  <option>Loading...</option>
                ) : (
                  taskStatusArr.map((option) => (
                    <option
                      key={option.display_order}
                      value={option.display_order}
                    >
                      {option.list_item}
                    </option>
                  ))
                )}
              </DropdownCust>
            </Box>

            <Grid container mt={1}>
            <div style={{gap:'8px', display:'flex', flexDirection:'row'}}>
              <Grid item xs={12} md={4}>
                <p className="DateNTime">Date & Time – Created</p>
                <TextFieldCust
                  fullWidth
                  label="Date & Time – Created"
                  value={dateTimeCreated}
                  margin="normal"
                  disabled
                  variant="outlined"
                  InputProps={{
                    startAdornment: <Create color="primary" />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
              <p className="DateNTime">Date & Time – Done</p>
                <TextFieldCust
                  fullWidth
                  label="Date & Time – Done"
                  value={dateTimeDone}
                  margin="normal"
                  disabled
                  variant="outlined"
                  InputProps={{
                    startAdornment: <Done color="primary" />,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
              <p className="DateNTime">Date & Time – Last Updated</p>
                <TextFieldCust
                  fullWidth
                  label="Date & Time – Last Updated"
                  value={dateTimeLastUpdate}
                  margin="normal"
                  disabled
                  variant="outlined"
                  InputProps={{
                    startAdornment: <Update color="primary" />,
                  }}
                />
              </Grid>
            </div>
            </Grid>

            <Box mt={1} mb={1}>
              <Typography variant="body2">
                <Assignment color="primary" style={{ marginRight: "10px" }} />
                Block Status
              </Typography>
              <DropdownCust
                value={selectedBlockStatus}
                onChange={handleBlockStatusChange}
                disabled={statusesLoading}
                placeholder="Select.."
              >
                {statusesLoading ? (
                  <option>Loading...</option>
                ) : (
                  blockStatusArr.map((option) => (
                    <option
                      key={option.display_order}
                      value={option.display_order}
                    >
                      {option.list_item}
                    </option>
                  ))
                )}
              </DropdownCust>

              {validator.message(
                "selectedBlockStatus",
                selectedBlockStatus,
                "required"
              )}
            </Box>

            <Box mt={1} mb={1}>
              <Typography variant="body2">
                <Person color="primary" style={{ marginRight: "10px" }} />
                Block Creator
              </Typography>

              <TextFieldCust
                value={isUserLoading ? "Loading..." : blockCreator || ""}
                disabled={true}
                placeholder=""
                fullWidth
              />
            </Box>

            {/* <TextField
              fullWidth
              label="Mapping (links)"
              value={mappingLinks}
              onChange={(e) => setMappingLinks(e.target.value)}
              margin="normal"
              variant="outlined"
              InputProps={{
                startAdornment: <Link color="primary" />,
              }}
            /> */}

            
            <div className="d-flex align-items-center mb-2">
             
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                <Tooltip title="Mapping (links)">
                  <IconButton onClick={handleOpen}>
                    <AddLinkIcon />
                  </IconButton>
                </Tooltip>
              </div>

              <Link
                component="button"
                variant="body2"
                onClick={() => handleOpenLinkedTickets('right')}
              >
                Linked Blocks
              </Link>

            <Badge sx={{mr:5}} badgeContent={linkedBlocks?.length} color="secondary" max={9}>
              <DriveFolderUploadRoundedIcon color="primary" fontSize="medium"/>
            </Badge>

              <Modal
                open={openLinked}
                onClose={handleCloseLinkedModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                <Typography variant="h6" component="div">
                  Linked Blocks
                </Typography>
                  {linkedBlocksForSearch && linkedBlocksForSearch.length > 0 &&
                    <Button onClick={()=>handleFilterForLinkedBlocksSearch(linkedBlocksForSearch)} variant="outlined" startIcon={<ContentPasteSearchIcon />}>
                      Populate Blocks
                    </Button>
                  }
                <List sx={{ pt: 0 }}>
                  {linkedBlocks.map((block, index) => (
                    <ListItem  
                      key={index} 
                      sx={{backgroundColor:'#d8d8d8', borderRadius:"20px",mt:3}}
                      secondaryAction={
                        <IconButton edge="end" aria-label="delete" onClick={()=>handleRemoveLink(block)}>
                          <CancelIcon />
                        </IconButton>
                      }
                    >

                      <ListItemAvatar>
                        <Checkbox
                          size="small"
                          sx={{
                            padding: '0 8px',
                            '&.Mui-checked': {
                              color: '#773e87'
                            }
                          }}
                          onChange={(event) => handleSelectLinkBlockForSearch(event, block)}
                          checked={linkedBlocksForSearch.length > 0 && linkedBlocksForSearch.some(b => b.block_id === block.block_id)}
                        />
                        </ListItemAvatar>
                      <ListItemText primary={`[${block.block_id}] ${block.comment}`} />
                    </ListItem>
                  ))}
                  
                </List>
                </Box>
              </Modal>
              
            
          </div>

            <Box mt={1} mb={1}>
              <Typography variant="body2">
                <Folder color="primary" style={{ marginRight: "10px" }} />
                Attachments
              </Typography>
              <Button
                variant="outlined"
                startIcon={<CloudUpload />}
                style={{ marginTop: "10px" }}
              >
                Upload Attachment
              </Button>
            </Box>

            {/* Save Button */}
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              fullWidth
              style={{ marginTop: "20px" }}
              disabled={saveLoading}
              sx={{ backgroundColor: "#1ea5d0", color: "white", marginTop: "16px" }}
            >
              {saveLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Save"
              )}
            </Button>

            {/* Footer Navigation */}
            <Box display="flex" justifyContent="space-between" mt={2}>
              {prevTicket && (
                <Button
                  variant="outlined"
                  startIcon={<ArrowBack />}
                  onClick={handlePrev}
                >
                  {parentBlockTitle}
                </Button>
              )}

              {nextTicket && (
                <Button
                  variant="outlined"
                  endIcon={<ArrowForward />}
                  onClick={handleNext}
                >
                  {nextBlockTitle}
                </Button>
              )}
            </Box>

              
          </CardContent>
        </Card>
      </Slide>
    </div>
  );

  const isMobile = useMediaQuery("(max-width:600px)");
  const drawerWidth = isMobile ? 300 : 600;

  return (
    <Drawer anchor="right" open={open} onClose={handleCloseDrawer}>
      <div style={{ width: drawerWidth, padding: 20 }}>
        {list()}
        {modalOpen &&
          <BlockLinkModal
            selectedBlock={selectedSearchFilter}
            handleClose={handleClose}
            modalOpen={modalOpen}
            handleAddLink={handleAddLink}
            linkedBlocks={linkedBlocks}
          />
        }
      </div>
    </Drawer>
  );
}
